"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const pattern_library_utils_price_format_1 = require("@saatva-bits/pattern-library.utils.price-format");
const PriceRange_module_scss_1 = __importDefault(require("./PriceRange.module.scss"));
/**
 * The price range components receives a price range object with base price and discounted price ranges
 * then formtats them for viewing
 *
 * @param {object} props
 * @param {{
 *  highestPrice: number,
 *  lowestPrice: number,
 *  lowestPriceDiscount: number,
 *  highestPriceDiscount: number
 * }} props.priceRange
 * @param {string} props.className
 * @param {string} props.discountClassName
 */
const PriceRange = ({ priceRange, className, discountClassName }) => {
    const { highestPrice, lowestPrice, lowestPriceDiscount, highestPriceDiscount } = priceRange;
    const priceContent = formattedPrice(lowestPrice, highestPrice);
    const hasDiscount = lowestPrice !== lowestPriceDiscount ||
        highestPrice !== highestPriceDiscount;
    const discountContent = hasDiscount && formattedPrice(lowestPriceDiscount, highestPriceDiscount);
    const priceClassNames = (0, classnames_1.default)(PriceRange_module_scss_1.default.price, className);
    const strikeThroughClassNames = (0, classnames_1.default)([PriceRange_module_scss_1.default.strikeThrough], discountClassName);
    const mainPrice = hasDiscount ? discountContent : priceContent;
    return ((0, jsx_runtime_1.jsxs)("div", { className: priceClassNames, children: [mainPrice, discountContent && ((0, jsx_runtime_1.jsx)("span", { className: strikeThroughClassNames, children: priceContent }))] }));
};
PriceRange.propTypes = {
    className: prop_types_1.default.string,
    discountClassName: prop_types_1.default.string,
    priceRange: prop_types_1.default.shape({
        highestPrice: prop_types_1.default.number.isRequired,
        lowestPrice: prop_types_1.default.number.isRequired,
        lowestPriceDiscount: prop_types_1.default.number.isRequired,
        highestPriceDiscount: prop_types_1.default.number.isRequired
    }).isRequired
};
function formattedPrice(lowPrice, highPrice) {
    const hasRange = highPrice > 0 && lowPrice !== highPrice;
    return hasRange
        ? `${(0, pattern_library_utils_price_format_1.formatCurrency)(lowPrice)} - ${(0, pattern_library_utils_price_format_1.formatCurrency)(highPrice)}`
        : (0, pattern_library_utils_price_format_1.formatCurrency)(lowPrice);
}
exports.default = PriceRange;
//# sourceMappingURL=PriceRange.js.map